import React, { FC } from 'react';

import MediaListItemProgressSlider from 'application/components/MediaList/MediaListItem/MediaListItemProgressSlider';
import { usePlayerContext } from 'application/providers/PlayerProvider';

import { DATA_TEST_IDS } from '../../../consts';

import styles from './index.module.scss';

type PromoOptionProgressProps = {
  promoId: string;
};

const PromoOptionProgress: FC<PromoOptionProgressProps> = ({ promoId }) => {
  const { changeProgress, fileUuid, progress } = usePlayerContext();

  if (fileUuid !== promoId) {
    return null;
  }

  return (
    <div
      className={styles.progress}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_OPTION_PROGRESS(promoId)}>
      <MediaListItemProgressSlider
        elementId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_OPTION_PROGRESS_INPUT(promoId)}
        progress={progress}
        isPromo
        onChange={changeProgress}
      />
    </div>
  );
};

export default PromoOptionProgress;
